import { preferredTenantPhone, tenantDisplayName } from "../utils/tenantProfile";

export default function TenantTable({ tenants, onViewFiles, onViewProfile }) {
  if (!tenants.length) return <p className="admin-empty-state">No tenants found.</p>;

  return (
    <div className="admin-table-wrap">
      <table className="admin-table admin-tenant-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Mailbox Number</th>
            <th>Files</th>
            <th>Profile</th>
          </tr>
        </thead>
        <tbody>
          {tenants.map((tenant) => {
            const phone = preferredTenantPhone(tenant);
            const mailboxNumbers = tenant.mailboxes?.map((mailbox) => mailbox.number).join(", ");
            return (
              <tr key={tenant.id}>
                <td>{tenantDisplayName(tenant)}</td>
                <td>{tenant.email}</td>
                <td>
                  {phone ? (
                    <span className="admin-contact-value">
                      {phone.number}
                      <small>{phone.type}</small>
                    </span>
                  ) : "—"}
                </td>
                <td>{mailboxNumbers || <span className="admin-muted-value">Unassigned</span>}</td>
                <td>
                  <button className="admin-button admin-button-secondary" type="button" onClick={() => onViewFiles(tenant)}>
                    Manage Files: [{tenant.documentCount || 0}]
                  </button>
                </td>
                <td>
                  <button className="admin-button admin-button-primary" type="button" onClick={() => onViewProfile(tenant)}>
                    View Profile
                  </button>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}
